export const getError = (error, multiple = false) => {
  if (!error) {
    return 'An unknown error occurred';
  }

  if (error.response?.data) {
    if (error.response.data.errors && Array.isArray(error.response.data.errors) && error.response.data.errors.length > 0) {
      if (!multiple) {
        const firstError = error.response.data.errors[0];
        return firstError.message || firstError || 'An error occurred';
      }
    }
    
    if (error.response.data.message) {
      return error.response.data.message;
    }
  }

  if (error.message) {
    return error.message;
  }

  return 'An unknown error occurred';
}
